// persist：保持，保留  subscribe：订阅
export default store => {
    // sotre 在初始化的时候，将存储在 localStorage 中的状态还原
    if (localStorage) {
        // const user = JSON.parse(localStorage.getItem('user'));
        // store.commit("amendState", { test: "persist-xuewei" })
        // if (user) {
        //     store.commit("amendState", { test: "persist-xuewei" })
        // }
    }

    // 如果用户相关的状态发生变化，自动存入 localStorage
    store.subscribe((mutation, state) => {
        // {type:'user/test'} || {type:test}
        // mutation.type.startWith('user/')
        // if (mutation.type) {
        //     const user = JSON.stringify(state.test);
        //     localStorage.setItem("user", user)
        // } else if (mutation.type === "xxx") {
        //     localStorage.removeItem("user")
        // }
    })
}


// WEBPACK FOOTER //
// ./src/store/plugin/persist.js